import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-events-new-event',
  templateUrl: './events-new-event.component.html',
  styleUrls: ['./events-new-event.component.scss']
})
export class EventsNewEventComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
